/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cost_Per_MinuteInputs */



/**
* | output |
* | --- |
* | "$1.00 USD per minute" |
*
* @param {Cost_Per_MinuteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cost_per_minute = /** @type {((inputs?: Cost_Per_MinuteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_Per_MinuteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("1,00 $ US par minute")
	if (locale === "de") return /** @type {LocalizedString} */ ("1,00 USD pro Minute")
	if (locale === "it") return /** @type {LocalizedString} */ ("1,00 USD al minuto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("1,00 доллар США в минуту")
	if (locale === "es") return /** @type {LocalizedString} */ ("1,00 USD por minuto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("每分钟 1.00 美元")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1分あたり1.00米ドル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("1.00 अमेरिकी डॉलर प्रति मिनट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("US$ 1,00 por minuto")
	return /** @type {LocalizedString} */ ("$1.00 USD per minute")
});